import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';
import { Bs7Circle } from 'react-icons/bs';

const EditCoefficient = ({ ucoefficient, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);

    const [coefficient, setCoefficient] = useState({
        id: ucoefficient.id,
        groupe: ucoefficient.groupe.libelle,
        matiere: ucoefficient.matiere.libelle,
        coeff: ucoefficient.coefficient,
        noteMax: ucoefficient.noteMax,
        ordre: ucoefficient.ordre,
    });


    const navigate = useNavigate();


    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/coefficient/update', coefficient)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header icon={<Bs7Circle />} title="Modifier un coefficient" titleAr="تحرير ضارب و تنقيط" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        {loading ? <Loading /> :
                            <>
                                <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                    <div className='flex-col w-full justify-evenly '>
                                        <div className='mr-2'>
                                            <Input label="Groupe" labelAr="المجموعة" readOnly={true} type="text" value={coefficient.groupe} onChange={ev => setCoefficient({ ...coefficient, groupe: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'> 
                                            <Input label="Matiere" labelAr="المادة" readOnly={true} type="text" value={coefficient.matiere} onChange={ev => setCoefficient({ ...coefficient, matiere: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Coefficient" labelAr="الضارب" type="text" value={coefficient.coeff} onChange={ev => setCoefficient({ ...coefficient, coeff: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Note Max" labelAr="التنقيط" type="text" value={coefficient.noteMax} onChange={ev => setCoefficient({ ...coefficient, noteMax: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Ordre" labelAr="الترتيب" type="text" value={coefficient.ordre} onChange={ev => setCoefficient({ ...coefficient, ordre: ev.target.value })} required="required" />
                                        </div>

                                    </div>
                                </div>
                            </>
                        }
                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditCoefficient